/* PavCon, LLC Proprietary.All rights reserved 2022 */

import { Actions, ofType, createEffect } from '@ngrx/effects';
import { AppParamsActions, AppParamsState, NAMESPACE } from '../app-params.reducer';
import { switchMap, catchError, tap } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { LocalStorageService } from '../../services/local-storage.service';
import { of } from 'rxjs';

@Injectable()
export class AppParamsEffects {

  constructor(private action$: Actions, private localStorage: LocalStorageService) {}

  init$ = createEffect(() =>
    this.action$.pipe(
      ofType(AppParamsActions.INIT),
      switchMap(() => {
        try {
          const local = this.localStorage?.get(NAMESPACE) as AppParamsState;
          if (local && typeof local === 'object') {
            return of({ type: AppParamsActions.SET_FILTERS, payload: local });
          } else {
            return of({ type: AppParamsActions.KEEP_CURRENT_STATE });
          }
        } catch (error) {
          return of({ type: AppParamsActions.KEEP_CURRENT_STATE });
        }
      }),
      catchError((error) => {
        return of({ type: AppParamsActions.KEEP_CURRENT_STATE });
      })
    )
  );

  updateStateAndLs$ = createEffect(() =>
    this.action$.pipe(
      ofType(AppParamsActions.UPDATE_STATE_AND_LS),
      tap((action: any) => {
        try {
          if (action?.payload && this.localStorage) {
            this.localStorage.set(NAMESPACE, action.payload);
          }
        } catch (error) {
          console.error('Error saving AppParams to localStorage:', error);
        }
      })
    ), { dispatch: false }
  );

  updateStateAndRemoveLs$ = createEffect(() =>
    this.action$.pipe(
      ofType(AppParamsActions.UPDATE_STATE_AND_REMOVE_LS),
      tap(() => {
        try {
          if (this.localStorage) {
            this.localStorage.remove(NAMESPACE);
          }
        } catch (error) {
          console.error('Error removing AppParams from localStorage:', error);
        }
      })
    ), { dispatch: false }
  );
}
/*Distribution Statement B. Distribution authorized to U.S. Government agencies only.PavCon, LLC Proprietary.All rights reserved.
   2020 WARNING: this file may contain export controlled information.*/
